module.exports = __webpack_public_path__ + "images/fontawesome-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./~/vue-blu/dist/fonts/fontawesome-webfont.woff
// module id = 951
// module chunks = 2